<template>
    <div class="blockquote container container--medium margin-top-sm margin-bottom-lg">
        <div class="html-content">
            <blockquote :author="data.author">
                <p v-html="data.quoted_text" />
                <em v-html="data.author" v-if="data.author"/>
            </blockquote>
        </div>
    </div>
</template>

<script>

export default {
    name: 'blockqoute',
    props: ['data'],
    computed:{
        
    },
    components:{
    },
};
</script>
